import Layout from '@/layout/index.vue'

export const campusMap = {
  path: '/yuansuo',
  component: Layout,
  meta: { title: '园务', code: 710207 },
  children: [
    {
      path: 'campus',
      component: () => import('@/views/yuansuo/campus/index.vue'),
      meta: { title: '校区管理', code: 745898, drop: true },
      children: [
        {
          path: 'campus',
          meta: { title: '校区管理', code: 500962 },
          component: () => import('@/views/yuansuo/campus/campus/index.vue'),
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/yuansuo/campus/campus/list.vue'),
              meta: { title: '校区列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () =>
                import('@/views/yuansuo/campus/campus/add.vue'),
              meta: { title: '添加校区', code: '' }
            },
            {
              path: 'edit',
              component: () =>
                import('@/views/yuansuo/campus/campus/add.vue'),
              meta: { title: '编辑校区', code: '' }
            },
            {
              path: 'detail',
              component: () =>
                import('@/views/yuansuo/campus/campus/add.vue'),
              meta: { title: '校区详情', code: '' }
            }
          ]
        }
      ]
    },
    {
      path: 'staffManage',
      component: () => import('@/views/yuansuo/staffManage/index.vue'),
      meta: { title: '员工管理', code: 640682, drop: true },
      children: [
        {
          path: 'teacher',
          component: () =>
            import('@/views/yuansuo/staffManage/teacher/index.vue'),
          meta: { title: '员工管理', code: 838390 },
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/yuansuo/staffManage/teacher/list.vue'),
              meta: { title: '员工列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () =>
                import('@/views/yuansuo/staffManage/teacher/add.vue'),
              meta: { title: '添加员工', code: '' }
            },
            {
              path: 'edit',
              component: () =>
                import('@/views/yuansuo/staffManage/teacher/add.vue'),
              meta: { title: '编辑员工', code: '' }
            },
            {
              path: 'detail',
              component: () =>
                import('@/views/yuansuo/staffManage/teacher/add.vue'),
              meta: { title: '员工详情', code: '' }
            }
          ]
        },
        {
          path: 'role',
          component: () => import('@/views/yuansuo/campus/role/index.vue'),
          meta: { title: '角色管理', code: 968305 },
          children: [
            {
              path: 'list',
              component: () => import('@/views/yuansuo/campus/role/list.vue'),
              meta: { title: '角色列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () => import('@/views/yuansuo/campus/role/add.vue'),
              meta: { title: '添加角色', code: '' }
            },
            {
              path: 'edit',
              component: () => import('@/views/yuansuo/campus/role/add.vue'),
              meta: { title: '编辑角色', code: '' }
            },
            {
              path: 'detail',
              component: () => import('@/views/yuansuo/campus/role/add.vue'),
              meta: { title: '角色详情', code: '' }
            }
          ]
        },
        {
          path: 'post',
          component: () =>
            import('@/views/yuansuo/staffManage/post/index.vue'),
          meta: { title: '岗位管理', code: 635965 },
          children: [
            {
              path: 'list',
              component: () =>
                import('@/views/yuansuo/staffManage/post/list.vue'),
              meta: { title: '岗位列表', keepAlive: true }
            },
            {
              path: 'add',
              component: () =>
                import('@/views/yuansuo/staffManage/post/add.vue'),
              meta: { title: '添加岗位', code: '' }
            },
            {
              path: 'edit',
              component: () =>
                import('@/views/yuansuo/staffManage/post/add.vue'),
              meta: { title: '编辑岗位', code: '' }
            },
            {
              path: 'detail',
              component: () =>
                import('@/views/yuansuo/staffManage/post/add.vue'),
              meta: { title: '岗位详情', code: '' }
            }
          ]
        }
      ]
    },
    {
      path: 'recheck',
      component: () => import('@/views/yuansuo/recheck/index.vue'),
      meta: { title: '复检抽查', code: 569397, drop: true },
      children: [
        {
          path: 'safe',
          meta: { title: '安全复检', code: 504155 },
          component: () => import('@/views/yuansuo/recheck/recheck/safeRecheck.vue')
        },
        {
          path: 'fire',
          meta: { title: '防火复检', code: 609178 },
          component: () => import('@/views/yuansuo/recheck/recheck/fireRecheck.vue')
        },
        {
          path: 'goods',
          meta: { title: '物品复检', code: 533427 },
          component: () => import('@/views/yuansuo/recheck/recheck/goodsRecheck.vue')
        },
        {
          path: 'hygiene',
          meta: { title: '消毒复检', code: 839599 },
          component: () => import('@/views/yuansuo/recheck/recheck/hygieneRecheck.vue')
        }
      ]
    },
    {
      path: 'notice',
      component: () => import('@/views/yuansuo/notice/index.vue'),
      meta: { title: '通知公告', code: 569397, noChildren: true },
      children: [
        { path: '', component: () => import('@/views/yuansuo/notice/list.vue'), meta: { title: '通知公告', code: 943649 } },
        { path: 'add', component: () => import('@/views/yuansuo/notice/edit.vue'), meta: { title: '新建', code: 969259, hidden: true } },
        { path: 'edit', component: () => import('@/views/yuansuo/notice/edit.vue'), meta: { title: '编辑', code: 969259, hidden: true } },
        { path: 'info', component: () => import('@/views/yuansuo/notice/info.vue'), meta: { title: '详情', code: 943649, hidden: true } }
      ]
    }
  ]
}
